import React from 'react';

interface Address {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

interface AddressDisplayProps {
  address: Address;
}

export const AddressDisplay = ({ address }: AddressDisplayProps) => {
  const { address1, address2, city, state, zip } = address;

  // Build the street line
  const streetLine = [ address1, address2 ].filter(Boolean).join(' ');

  // Build the city/state/zip line
  const cityStateZip = [ city, state && zip ? `${state} ${zip}` : state || zip ]
    .filter(Boolean)
    .join(', ');

  // If no address info at all, return null
  if (!streetLine && !cityStateZip) {
    return null;
  }

  return (
    <div className="">
      {streetLine && <div className="capitalize">{streetLine}</div>}
      {cityStateZip && <div className="capitalize">{cityStateZip}</div>}
    </div>
  );
};
